'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamor = require('glamor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Loader
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
var keyframes = _glamor.css.keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' }
});
// import PropTypes from 'prop-types';

var keyframesName = keyframes.toString();

var loader = (0, _glamor.css)({
  border: '2px solid #f3f3f3',
  borderTop: '2px solid #555',
  borderRadius: '50%',
  width: 30,
  height: 30,
  animation: keyframesName + ' 1s linear infinite'
});
var loaderClass = loader.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/**
  * Loader - React Element that renders a link to an external URL.
  */
var Loader = function Loader() {
  return _react2.default.createElement('div', { className: loaderClass });
};

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------------Typing
// ------------------------------------------------------------------------------
Loader.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = Loader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/components/lib/Loader.js
// module id = 312
// module chunks = 168707334958949